export default {
  getTime: (state) => {
    return state.time;
  },
  getTimes: (state) => {
    return state.times;
  },
};
